export class PreparationDetModel{
prepautoserial = 0;
prepmasterID='';
patientID ='';
prepprotocolID ='';
category  ='';
drgserial  ='';
drgName ='';
perpDaose =0;
cDSA ='';
uOM ='';
unName ='';
prepDR  ='';
prepFD  ='00.00';
unName1 ='';
prepFU  ='';
prepdisp = '00.00';
prepsaved = '00.00';
prepRout ='';
prepDuration ='';
prepImportant ='';
preSolution ='';
prepDone ='';
prepTimeDone ='07:00 AM';
prepPharmacy ='';
categoryName ='';
compCode ='1';
userID ='sa';
modifiedDate ='2022-01-01';
}
export class PreparationDetNurseModel{
  prepimportant = 0 ;
  prepmasterid = '' ;
  patientid = '' ;
  prepprotocolid = '' ;
  category = '' ;
  drgsconcatenate = '' ;
  solution = '' ;
  prepduration = '' ;
  preprout = '' ;
  ardrgsconcatenate = '' ;
  strattime  = '07:00 AM';
  enditime  = '07:00 AM';
  nursecomments = '';
  nursecomments1 = '';

}

